module.exports = __webpack_public_path__ + "img/syllabus-level3.1370d841.png";